"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TableHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function TableHeader(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
            {
                flexDirection: 'row',
                justifyContent: 'center',
                paddingVertical: 4,
                backgroundColor: THEME.SmokeWhite,
                borderRadius: 2
            },
            props.style
        ], children: props.columns != null &&
            props.columns.length > 0 &&
            props.columns.map((c, i) => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                    {
                        justifyContent: 'center',
                        flex: c.flex,
                        alignItems: c.align ?? 'center',
                    },
                    c.viewStyle
                ], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": c.accLabel ?? c.label, style: [
                        {
                            fontSize: size != 'sm' ? 14 : 12,
                            fontWeight: '500',
                            textAlign: c.align == 'center' ? 'center' : null,
                            color: THEME.SmokeWhiteText,
                            marginLeft: c.align == 'flex-end' ? 0 : (c.indent ?? 0),
                            marginRight: c.align == 'flex-end' ? (c.indent ?? 0) : 0
                        },
                        c.textStyle
                    ], children: c.label }) }, i)) }));
}
;
